export const firebaseConfig = {
  apiKey: "AIzaSyBQ9HTG8Lbvpu08fIT9h-nSgVgbzS-gCZU",
  authDomain: "pc-uniservicios.firebaseapp.com",
  projectId: "pc-uniservicios",
  storageBucket: "pc-uniservicios.appspot.com",
  messagingSenderId: "609309442310",
  appId: "1:609309442310:web:a8a574d34a39507de11e87"
};